import {mainServer} from '../../../../../variables/config'

export const request_credit_card = async (credit_card_id) => {
  const logData = JSON.parse(localStorage.getItem('data'))
  mainServer.instance.defaults.headers.common['Authorization'] = logData.token
  let response = await mainServer.instance.get(`/creditcard/${credit_card_id}`)
  return response.data.data.credit_card
}

